import React, { Component } from "react";
import PanelLeft from "./PanelLeft/PanelLeft";
import PanelRight from "./PanelRight/PanelRight";
import Loading from "../Loading/Loading";
import "./Search.css";

class Search extends Component {
	componentWillMount(){
		//this.industries = this.props.returnIndustriesArray();
		this.props.resetQuery();
	}
	render() {
		return (
			<div className="container search-page">
				{this.props.requestInProgress === true && <Loading />}
				<PanelLeft
					query={this.props.query}
					countries={this.props.countries}
					//industries={this.industries}
					moreFilters={this.props.moreFilters}
					toggleMoreFilters={this.props.toggleMoreFilters}
					addSearchTypeToQuery={this.props.addSearchTypeToQuery}
					buildSearchQuery={this.props.buildSearchQuery}
					searchProducts={this.props.searchProducts}
				/>
				<PanelRight
					resetQuery={this.props.resetQuery}
					trianglify={this.props.trianglify}
					query={this.props.query}
					validateSearchQuery={this.props.validateSearchQuery}
					buildSearchQuery={this.props.buildSearchQuery}
				/>
			</div>
		);
	}
}

export default Search;


// WEBPACK FOOTER //
// ./src/components/Search/Search.js